import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import {none, option, Option} from "ts-option";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import DataGrid from "../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import {api} from "../../api/api";
import {PartnerBrandSearch} from "../../model/partnerBrand/PartnerBrand";
import {CommonDetailsStatusRow} from "./common/CommonDetailsStatusRow";
import GeneralLedger from "../../model/generalLedger/GeneralLedger";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import DateRangePickerComponent from "../ui/datepicker/DateRangePickerComponent";
import CurrencyHelper from "../../helper/CurrencyHelper";
import PartnerBrandSelectionComponent from "../partnerBrand/search/PartnerBrandSelectionComponent";
import "./generalLedgerView.scss";
import moment = require("moment");

const arrow = require('../../../resources/hiber/img/guide-arrow.png');

interface State {
	/**
	 * General ledger.
	 */
	generalLedger: Option<GeneralLedger>;
	/**
	 * Date from.
	 */
	dateFrom: moment.Moment;
	/**
	 * Date to.
	 */
	dateTo: moment.Moment;
	/**
	 * Selected partner brand.
	 */
	selectedPartnerBrand: Option<PartnerBrandSearch>;
}

type Props = RouteComponentProps<{}> ;

/**
 * General ledger view
 */
class GeneralLedgerView extends React.PureComponent <Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {generalLedger: none, dateFrom: moment().startOf('month'), dateTo: moment(), selectedPartnerBrand: none}
	}

	fetchGeneralLedgerData = () => {
		this.state.selectedPartnerBrand.map(pb => {
				api.instance.generalLedgerApi.fetchGeneralLedger(pb.id, this.state.dateFrom, this.state.dateTo)
					.then(generalLedger => this.setState({generalLedger: option(generalLedger)}))
					.catch(error => {
						notifyBugsnagAndShowToast(error, "Fetch general ledger");
					})
			}
		).getOrElse(() => this.setState({generalLedger: none}));
	};

	render() {
		return (
			<div className={"l-page"}>
				<CommonDetailsStatusRow icon={Icon.Quote}
										title={"General ledger"}
										onBackClick={this.props.history.goBack}
										refNumPath={["Accounting", "General ledger"]}
										additionalComponent={this.renderPartnerBrandSelector()}/>
				<div className="c-general-ledger_date-picker">
					<DateRangePickerComponent from={this.state.dateFrom}
											  to={this.state.dateTo}
											  onChange={this.onDateChanged}/>
				</div>
				{this.renderTable()}
			</div>
		);
	}

	onDateChanged = (dateFrom: moment.Moment, dateTo: moment.Moment) => this.setState({dateFrom, dateTo},
		this.fetchGeneralLedgerData);

	renderTable = () => {
		return (this.state.generalLedger.map(ledger => {
				if (!ledger.accountSummary.length) {
					return this.renderNoDataContent();
				}
				return <DataGrid>
					<thead>
					<tr className="c-common-details_table-header-row">
						<th className="c-common-details_table-desc-cell">ACCOUNT</th>
						<th>DEBIT</th>
						<th>CREDIT</th>
						<th>NET MOVEMENT</th>
					</tr>
					</thead>
					<tbody>
					{ledger.accountSummary.map((item, index) =>
						<tr key={index} className="c-common-details_table-row">
							<td className="c-common-details_table-desc-cell">{item.name}</td>
							<td>{CurrencyHelper.toCurrency(item.summary.debit)}</td>
							<td>{CurrencyHelper.toCurrency(item.summary.credit)}</td>
							<td>{CurrencyHelper.toCurrency(item.summary.netMovement)}</td>
						</tr>)}
					<tr className="c-common-details_table-row font-bold">
						<td className="c-common-details_table-desc-cell">{"Total"}</td>
						<td>{CurrencyHelper.toCurrency(ledger.summary.debit)}</td>
						<td>{CurrencyHelper.toCurrency(ledger.summary.credit)}</td>
						<td>{CurrencyHelper.toCurrency(ledger.summary.netMovement)}</td>
					</tr>
					</tbody>
				</DataGrid>
			}).getOrElse(this.renderNoPbSelectedContent)
		);
	};

	renderPartnerBrandSelector = () => {
		return (
			<div className="c-common-details_partner-brand-selector">
				<PartnerBrandSelectionComponent selectedValue={this.state.selectedPartnerBrand}
												onSelect={this.onPartnerBrandChange}
												placeholder="Choose a partner brand..."/>
			</div>
		);
	};

	renderNoPbSelectedContent = () => {
		return (
			<div>
				<img src={arrow} className="c-common-details_no-pb-selected-warning_partner-brand-guide-arrow"/>
				<div className="c-common-details_no-pb-selected-warning_text">
					Please choose a partner brand to continue.
				</div>
			</div>
		);
	};

	renderNoDataContent = () => {
		return (
			<div className="c-common-details_no-pb-selected-warning_text">
				No data for selected partner brand in this date range.
			</div>
		);
	};

	onPartnerBrandChange = (selectedPartnerBrand: Option<PartnerBrandSearch>) => this.setState({selectedPartnerBrand},
		this.fetchGeneralLedgerData);
}

export default withRouter(GeneralLedgerView)
